<template>
  <div class="gce-root">

    <!-- Main Page Section -->
    <div class="gce-wrapper">
      <div class="gce-card col-12 col-md-8">
        <h2 class="title">GCE Equivalence Portal</h2>
        <h4 class="text-danger pb-4"> ***(Only For O Level or A Level Students)*** </h4>

        <div class="col-12 d-flex flex-column flex-md-row gap-4 gap-md-3 justify-content-center">
            <div v-if="isRegistrationOpen" class="card h-100 border-info shadow-sm w-100"
                style="border-width: 2px; border-radius: 16px; transition: all 0.3s ease;"
                onmouseover="this.style.transform='translateY(-8px)'; this.style.boxShadow='0 12px 24px rgba(0, 0, 0, 0.15)';"
                onmouseout="this.style.transform=''; this.style.boxShadow='';">

                <div class="card-body text-center d-flex flex-column justify-content-between p-4">
                <h5 class="card-title text-info fw-bold mb-4"
                    style="font-size: clamp(1rem, 2vw, 1.125rem);">
                    GCE Equivalence Registration
                </h5>

                <button class="btn btn-info btn-lg w-100 text-white"
                        @click="goToRegistration"
                        style="border-radius: 12px; font-size: clamp(0.875rem, 1.5vw, 1rem); padding: 0.75rem 1.5rem; font-weight: 600;">
                    Register
                </button>
                </div>

            </div>
            <div class="card h-100 border-success shadow-sm w-100"
                style="border-width: 2px; border-radius: 16px; transition: all 0.3s ease;"
                onmouseover="this.style.transform='translateY(-8px)'; this.style.boxShadow='0 12px 24px rgba(0, 0, 0, 0.15)';"
                onmouseout="this.style.transform=''; this.style.boxShadow='';">

                <div class="card-body text-center d-flex flex-column justify-content-between p-4">
                <h5 class="card-title text-success fw-bold mb-4"
                    style="font-size: clamp(1rem, 2vw, 1.125rem);">
                    GCE Equivalence Applicant
                </h5>

                <button class="btn btn-success btn-lg w-100"
                        @click="goToLogin"
                        style="border-radius: 12px; font-size: clamp(0.875rem, 1.5vw, 1rem); padding: 0.75rem 1.5rem; font-weight: 600;">
                    Log In
                </button>
                </div>

            </div>
            <div class="card h-100 border-primary shadow-sm w-100"
                style="border-width: 2px; border-radius: 16px; transition: all 0.3s ease;"
                onmouseover="this.style.transform='translateY(-8px)'; this.style.boxShadow='0 12px 24px rgba(0, 0, 0, 0.15)';"
                onmouseout="this.style.transform=''; this.style.boxShadow='';">

                <div class="card-body text-center d-flex flex-column justify-content-between p-4">
                <h5 class="card-title text-primary fw-bold mb-4"
                    style="font-size: clamp(1rem, 2vw, 1.125rem);">
                    GCE Guideline
                </h5>

                <button class="btn btn-primary btn-lg w-100 text-white"
                        @click="goToGuideline"
                        style="border-radius: 12px; font-size: clamp(0.875rem, 1.5vw, 1rem); padding: 0.75rem 1.5rem; font-weight: 600;">
                    View Guideline
                </button>
                </div>

            </div>
        </div>
        

      </div>
    </div>

    <!-- Registration Modal -->
    <b-modal id="registrationModal" hide-footer size="lg">
      <template #modal-title>
        GCE Equivalence Application Registration
      </template>

      <gceregistration />
    </b-modal>

    <!-- Login Modal -->
    <b-modal id="loginModal" hide-footer size="md">
      <template #modal-title>
        GCE Equivalence pplicant Log In
      </template>

      <gcelogin ></gcelogin>
    </b-modal>

  </div>
</template>

<script>
import { GET_GCE_DATES } from '../../const/api';
import { GET } from '../../utils/GCERequest';

export default {
    name: "GCELanding",
    data () {
      return {
        registrationStartDate: null,
        registrationEndDate: null,
        isRegistrationOpen: true,
      }
    },
    components: {
      gceregistration: () => import('../Auth/GCE/GCERegistration.vue'),
      gcelogin: () => import('../Auth/GCE/GCELogin'),
    },
  methods: {
    goToRegistration() {
    //   this.$bvModal.show("registrationModal");
        window.location.href = '/gce/registration';
    },
    goToLogin() {
    //   this.$bvModal.show("loginModal");
        window.location.href = '/gce/login';
    },
    goToGuideline() {
        window.open('/gce-guideline', '_blank');
    }
  },
  async mounted() {

    // GCERegistration
    // GCEPayment
    // GCEApply
    
    const response = await GET(GET_GCE_DATES);
    const regItem = response.data.find(item => item.key === "GCERegistration");
    if (regItem) {
      this.registrationStartDate = regItem.startDate
      this.registrationEndDate = regItem.closeDate
      const currentDate = new Date();
      const startDate = new Date(this.registrationStartDate);
      const endDate = new Date(this.registrationEndDate);
      this.isRegistrationOpen = currentDate >= startDate && currentDate <= endDate;
    }
  },
};
</script>

<style scoped>
.gce-wrapper {
    min-height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: url('../../theme-assets/images/event/cu_front_gate.jpg');
    background-size: cover;
}

.gce-card {
  background: #ffffff;
  padding: 40px 30px;
  width: 100%;
  border-radius: 18px;
  box-shadow: 0 4px 16px rgba(61, 61, 61, 0.06);
  text-align: center;
}

.title {
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: 600;
  color:rgb(50, 21, 117);
}

</style>
